import { render, staticRenderFns } from "./SubstanceFieldDisplayEdit.vue?vue&type=template&id=18cec274&scoped=true&"
import script from "./SubstanceFieldDisplayEdit.vue?vue&type=script&lang=js&"
export * from "./SubstanceFieldDisplayEdit.vue?vue&type=script&lang=js&"
import style0 from "./SubstanceFieldDisplayEdit.vue?vue&type=style&index=0&id=18cec274&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cec274",
  null
  
)

export default component.exports